// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

import React from 'react';
//import ReactDOM from "react-dom";
import { useEffect, useState } from "react";
import '../App.css';
import * as microsoftTeams from "@microsoft/teams-js";

/**
 * The 'PersonalTab' component renders the main tab content
 * of your app.
 */
const IntegrationCard = () => {

    const [loaded, setLoaded] = useState(false);

    const loadIntegrationLib = (callback) => {
        const existingScript = document.getElementById('sap-ui-bootstrap'); if (!existingScript) {
            const script = document.createElement('script');
            script.src = 'https://ui5.sap.com/resources/sap-ui-integration.js'; script.id = 'sap-ui-bootstrap';
            document.body.appendChild(script); script.onload = () => {
                if (callback) callback();
            };
        } if (existingScript && callback) callback();
    };



    useEffect(() => {
        loadIntegrationLib(() => setLoaded(true));
    });




    return (
        <div width="100px">
            {loaded ?
                <ui-integration-card class="ui5card"
                    manifest="/manifest.json">
                </ui-integration-card>
                : ''}
        </div>
    );
}

export default IntegrationCard;